import { render, staticRenderFns } from "./SigninWallScreen.vue?vue&type=template&id=618cfe6d&scoped=true"
import script from "./SigninWallScreen.vue?vue&type=script&lang=js"
export * from "./SigninWallScreen.vue?vue&type=script&lang=js"
import style0 from "./SigninWallScreen.vue?vue&type=style&index=0&id=618cfe6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cfe6d",
  null
  
)

export default component.exports